import React, { FC } from 'react';
import { IAmountsOwedReportsTableColumnHeading } from 'features/amountsOwedReports/amountsOwedReportsTypes';

interface TableHeadItemProps {
  item: IAmountsOwedReportsTableColumnHeading;
}

const TableHeadItem: FC<TableHeadItemProps> = ({ item }) => {
  return (
    <>
      <th>{item.title}</th>
    </>
  );
};

export default TableHeadItem;
